export default {
    FETCHED_PAYMENT: 'FETCHED_PAYMENT',
    FETCHED_MERCHANT_PAYMENT: 'FETCHED_MERCHANT_PAYMENT',
    FETCHED_PAYMENT_DETAILS: 'FETCHED_PAYMENT_DETAILS',
    AUTOMATION_DATA_FOR_TRADITIONAL: 'AUTOMATION_DATA_FOR_TRADITIONAL',
    TRADITIONAL_SETTLEMENT: "TRADITIONAL_SETTLEMENT",
    GET_ECOM_SETTLEMENT_DATA: "GET_ECOM_SETTLEMENT_DATA",
    GET_TRADITIONAL_SETTLEMENT_EDIT_DATA: "GET_TRADITIONAL_SETTLEMENT_EDIT_DATA"
}